import React, { useState, useEffect } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import axios from 'axios';
import { DatePicker } from "zaman";
import Visit from "../../assets/icon/NewsIcons/MainAdmin/VisitChart";
import Report from "../../assets/icon/NewsIcons/MainAdmin/NewsReport";
import { MainAdminNewsesTopDropDown } from "../../components";
import { useNavigate } from "react-router-dom";
import { axiosReq } from "../../commons/axiosReq";
import Cookies from 'universal-cookie';
import moment from 'moment-jalaali';

const MainAdminVisits = () => {
    const [data, setData] = useState([]);
    const [timeRange, setTimeRange] = useState('monthly'); // 'daily', 'weekly', 'monthly', 'yearly'
    const [startDate, setStartDate] = useState(moment().subtract(4, 'months').format('jYYYY/jMM/jDD'));
    const [endDate, setEndDate] = useState(moment().format('jYYYY/jMM/jDD'));
    const [labels, setLabels] = useState('');
    const [view, setView] = useState('');

    const showItems = [{ label: "روزانه", value: 'daily' }, { label: "هفتگی", value: 'weekly' }, 
        { label: "ماهانه", value: 'monthly' }, { label: "سالیانه", value: 'yearly' }];


    let navigate = useNavigate();
    
    
    
      
       
    const GetData = async () => {
        const writersData = await axiosReq("Admins/GetCounts?timeRange=" + timeRange + "&&startDate=" + startDate + "&&endDate=" + endDate, "get");
        console.log('slmmm')
        console.log(startDate)
        console.log(writersData)
        var ss=[];
        writersData.result.map((item)=>
            
            {
                if (item.date.length === 7) {
        ss.push({name:formatDateTimeMonthly(item.date),view:item.views})
    } else if (item.date.length === 4) {
        ss.push({name:formatDateTimeYearly(item.date),view:item.views})
    }
    else {
        ss.push({name:formatDateTime(item.date),view:item.views})
    }
}
        )
        setData(ss)
        setView(writersData.total)
    }
    const auth = async () => {
        const cookies = new Cookies();
        var token = cookies.get('token');
        console.log(token)
        console.log(cookies.get('role'))
        if (!token) {
            navigate("/admin");
        } else {
        if( cookies.get('role')=="Admin" )
            {   
            GetData()
            }
        else {
            navigate("/admin");
            }
        }
    }
    useEffect(() => {
        auth()
    }, [timeRange, startDate, endDate]);

    // useEffect(() => {
    //     const fetchData = async () => {
    //         try {
    //             const response = await axios.get('/api/visits', {
    //                 params: {
    //                     timeRange,
    //                     startDate,
    //                     endDate
    //                 }
    //             });
    //             setData(response.data);
    //         } catch (error) {
    //             console.error('Error fetching data:', error);
    //         }
    //     };

    //     fetchData();
    // }, [timeRange, startDate, endDate]);

    const fixNumbers = function (str) {
        var
            persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
            arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g]
        if (typeof str === 'string') {
            for (var i = 0; i < 10; i++) {
                str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
            }
        }
        return str;
    };
    const formatDateTime = (sDate) => {
        console.log(sDate)
        var lDate = new Date(sDate).toLocaleDateString('fa-IR');
        console.log(555)
        console.log(lDate)
        var d = fixNumbers(lDate.split('/')[2]);
        var dd = d < 10 ? '0' + d : d;
        var yyyy = fixNumbers(lDate.split('/')[0]);
        var mon = fixNumbers(lDate.split('/')[1]);
        var mm = (mon < 10 ? '0' + mon : mon);


        
        console.log(yyyy + '/' + mm + '/' + dd);
        return yyyy + '/' + mm + '/' + dd;
    }
    const formatDateTimeMonthly = (sDate) => {
        console.log(sDate)
        var lDate = new Date(sDate).toLocaleDateString('fa-IR');
        console.log(555)
        console.log(lDate)
        var d = fixNumbers(lDate.split('/')[2]);
        var dd = d < 10 ? '0' + d : d;
        var yyyy = fixNumbers(lDate.split('/')[0]);
        var mon = fixNumbers(lDate.split('/')[1]);
        var mm = (mon < 10 ? '0' + mon : mon);


        
        console.log(yyyy + '/' + mm + '/' + dd);
        return yyyy + '/' + mm ;
    }
    const formatDateTimeYearly = (sDate) => {
        console.log(sDate)
        var lDate = new Date(sDate).toLocaleDateString('fa-IR');
        console.log(555)
        console.log(lDate)
        var d = fixNumbers(lDate.split('/')[2]);
        var dd = d < 10 ? '0' + d : d;
        var yyyy = fixNumbers(lDate.split('/')[0]);
        var mon = fixNumbers(lDate.split('/')[1]);
        var mm = (mon < 10 ? '0' + mon : mon);


        
        console.log(yyyy + '/' + mm + '/' + dd);
        return yyyy ;
    }

    const CustomLegend = () => {
        return (
            <div style={{ fontFamily: 'IRANYekanBold', textAlign: 'center', width: '100%', marginTop: '40px', paddingLeft: '80px' }}>
                <span style={{ color: '#8884d8' }}>●</span> نمودار تعداد بازدید در هر تاریخ
            </div>
        );
    };

    return (
        <div>
            <div className="pt-[17px] px-[20px] border-b-2 border-borderGray">
            <div className="w-full flex justify-between items-center mb-[40px]">
                <div className="flex justify-start items-center">
                    <div><Visit color={'#184548'} /></div>
                    <p className="font-IRANYekanExtra text-[16px] text-mainColor2 mr-[10px]">بازدید ها</p>
                </div>
                <div className="flex items-center">
                    <div className="w-[121px] h-[40px] bg-Orange2 hoverBgYellow shadow-search-shadow rounded-[10px] flex justify-center items-center">
                        <div><Report /></div>
                        <p className="font-IRANYekanBold text-[14px] text-white mr-[7px]">گزارش گیری</p>
                    </div>
                </div>
            </div>
            <div className='flex justify-start items-center'>
            <div className="flex items-center mb-[20px] ml-6">
                    <div className="w-[122px] ml-3">
                        <p className="font-IRANYekanBold text-[15px] text-mainColor2">دسته بندی زمانی :</p>
                    </div>
                    <div className="w-[223px] ml-[15px] h-[40px] rounded-[10px] shadow-search-shadow">
                        <MainAdminNewsesTopDropDown
                            mainText={labels?labels:"ماهانه"}
                            items={showItems}
                            all={false}
                            set={setTimeRange}
                            setLabel={setLabels}
                            mainTextSize={15} /></div>
            </div>
            <div className="w-full flex justify-start items-center mb-[20px]">
                           <p className="font-IRANYekanBold text-[15px] text-mainColor2 ml-[15px]">بازه زمانی :</p>
                           <div className="w-[180px] flex justify-start items-center px-3 ml-[15px] h-[40px] rounded-[10px] shadow-search-shadow">
                           <DatePicker placeholder="تاریخ"
                            name="startDate"
                            value={startDate}
                            defaultValue={moment().subtract(4, 'months').toDate()}
                            onChange={(e) => {
                            // setAllValues({ ...allValues,TravelDate:formatDateTime(e.value)});
                            //   setAllValuesError({ ...allValuesError, TravelDate: false }); 
                            setStartDate(formatDateTime(e.value));
                            }}
                            

                          /></div>
                          <p className="font-IRANYekanBold text-[15px] text-mainColor2 ml-[15px]">لغایت</p>
                          <div className="w-[180px] flex justify-start items-center px-3 ml-[15px] h-[40px] rounded-[10px] shadow-search-shadow">
                           <DatePicker placeholder="تاریخ"
                            name="endDate"
                            value={endDate}
                            defaultValue={new Date()}
                            onChange={(e) => {
                            //   // setAllValues({ ...allValues,TravelDate:formatDateTime(e.value)});
                            //   setAllValuesError({ ...allValuesError, TravelDate: false });
                            setEndDate(formatDateTime(e.value)); 
                            }}
            
                          /></div>
                          
                        </div>
            </div>
            </div>
            {/* <h2>Visits Chart</h2>
            <div>
                <label>Time Range: </label>
                <select value={timeRange} onChange={(e) => setTimeRange(e.target.value)}>
                    <option value="daily">Daily</option>
                    <option value="weekly">Weekly</option>
                    <option value="monthly">Monthly</option>
                    <option value="yearly">Yearly</option>
                </select>
                <label>Start Date: </label>
                <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                <label>End Date: </label>
                <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
            </div> */}
            <div className="w-full flex justify-center items-center pr-11 pt-14 pb-8">
            <ResponsiveContainer width="90%" height={400}>
                
                <LineChart data={data}>
                
                <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" tick={{dy: 10, fontFamily: "IRANYekanBold"}} />
          <YAxis tick={{dx: -27, fontFamily: "IRANYekanBold"}}/>
          <Tooltip/>
          <Legend content={<CustomLegend />}/>
          
          <Line type="monotone" dataKey="view" stroke="#8884d8" activeDot={{ r: 8 }} />
          
                </LineChart>
                
            </ResponsiveContainer>
            </div>
            <div className='flex pb-5 w-[91%] mr-[9%] mt-4'>
                <p className='font-IRANYekanBold text-[16px] ml-3'>مجموع تعداد بازدید در بازه زمانی انتخاب شده :</p>
                <p className='font-IRANYekanExtra text-darkGray text-[16px]'>{view}</p>
            </div>
        </div>
    );
};

export default MainAdminVisits;